import TambahkanAnime from "./src/TambahkanAnime";

export default TambahkanAnime